import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'projects',
            name: 'project',
            class: 'Modules\\Site\\Entities\\Project'
        }
    }
}